"use client";

import styles from "./AuthorizePageHeader.module.scss";

import { WEBSITE_URL } from "@/constants";
import { withLocale } from "@/helpers";
import { useLocale } from "@/i18n";
import { Flex } from "@vetty/ui";
import { Link } from "react-router-dom";

/**
 * AuthorizePageHeader Component
 *
 * Navigation header for authorize page with logo and menu links.
 * Provides branding and navigation options for unauthenticated users.
 */
export const AuthorizePageHeader = () => {
  const locale = useLocale();
  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      {/* Company logo - links to main website */}
      <a href={`${WEBSITE_URL}/${locale}`} className={styles["comp__logo-link"]}>
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      {/* Navigation menu */}
      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        {/* Contact sales link */}
        <a
          href={`${WEBSITE_URL}/${locale}/university#contact-sales`}
          className={styles["comp__menu__item"]}
        >
          Contact sales
        </a>

        <Link
          to={withLocale(locale, "/sign-up")}
          className={styles["comp__menu__item"]}
        >
          Sign Up
        </Link>
      </Flex>
    </Flex>
  );
};
